function applyMove360TicketsPremiumScope() {
  const path = window.location.pathname || "";
  const active = path.startsWith("/tickets");
  document.body.classList.toggle("move360-tickets-premium", active);
}

applyMove360TicketsPremiumScope();
setInterval(applyMove360TicketsPremiumScope, 1000);
window.addEventListener("popstate", applyMove360TicketsPremiumScope);
window.addEventListener("hashchange", applyMove360TicketsPremiumScope);
